import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import type { CalculatorState } from "./pricing-calculator";
import { T } from "./pricing-shared";

/** Base-fee line item shown only below 900 units. */
export function SupportFeeRow({
  calc,
}: {
  readonly calc: CalculatorState;
}): ReactNode {
  const t = useTranslations("public.pricingSupportFeeRow");
  if (!calc.hasSupportFee) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12,
        padding: "12px 2px 0",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: T.sans,
            fontSize: 14.5,
            fontWeight: 600,
            color: T.ink,
          }}
        >
          {t("grundgebuehr")}
        </div>
        <div
          style={{
            fontFamily: T.sans,
            fontSize: 12,
            lineHeight: 1.45,
            color: "#8A8D94",
            marginTop: 3,
          }}
        >
          {t("fuerVerwaltungen900Einheiten")}
        </div>
      </div>
      <span
        style={{
          fontFamily: T.sans,
          fontSize: 14.5,
          fontWeight: 600,
          color: T.ink,
          flex: "none",
        }}
      >
        {calc.supportFeeLabel} €
      </span>
    </div>
  );
}
